/** Name to display for team */
export const TEAM_DISPLAY_NAME = "team";

/** Name to display for teams */
export const TEAMS_DISPLAY_NAME = "teams";

/** Reason shown next to a member that cannot be added to a team because they are in it already */
export const ALREADY_IN_TEAM_MESSAGE = `Already in this ${TEAM_DISPLAY_NAME}`;

/** Message shown when a member cannot be removed from a project assigned through a team */
export const REMOVE_MEMBER_THROUGH_TEAM_MESSAGE = "You cannot remove this member because they were assigned to the project through a team.";

/** Message shown when a member's project role cannot be changed because it comes through a team */
export const CHANGE_ROLE_THROUGH_TEAM_MESSAGE = "This member is part of a team that has access to this project.";

/**
 * Minimum number of characters required to start a team members search.
 * The backend rejects searches shorter than this (search length must be between 3 and 255).
 */
export const MIN_CHARACTERS_FOR_TEAM_MEMBERS_SEARCH = 3;

/**
 * @returns true if the search query satisfies the backend length requirement for team members
 * @param search Search query to validate
 */
export function isValidTeamMembersSearchQuery(search) {
  return search.trim().length >= MIN_CHARACTERS_FOR_TEAM_MEMBERS_SEARCH;
}